import $ from "jquery";

let $allGameElements = $('#section2').find('.game-item');
const $winnerCarousels = $('#section1').find('.winner-carousel');

function isScrolledIntoView(elem) {
	const $elem = $(elem);
	const $window = $(window);
	const docViewTop = $window.scrollTop();
	const docViewBottom = docViewTop + $window.height();
	const elemTop = $elem.offset().top;
	const elemBottom = elemTop + $elem.height();

	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
	$winnerCarousels.each(function (index, value) {
		if (isScrolledIntoView(value)) {
			if (!$(this).prop('no-slide')) {
				$(this).find('.gallery').slick('slickNext');
				$(this).prop('no-slide', true);
			}
		}
	});
});

function setupClickHandler($winnerItemCell) {
	$winnerItemCell.on('click', function (e) {
		console.log($(this));
		const gameId = $winnerItemCell.attr('data-gameid');
		const $game = $('#section2').find(`[data-gameid='${gameId}']`);

		//trigger click on game item
		$game.find('img').trigger('click');
	});
}

function setupWinnerItems() {
	$allGameElements = $('#section2').find('.game-item');
	const $winnerCells = $('.winners');

	$winnerCells.each(function (i, value) {
		const $winnerCell = $winnerCells.eq(i);
		const gameId = $winnerCell.attr('data-gameid');

		//setup game name and image

		$allGameElements.filter(function () {
			return $(this).attr('data-gameid') === gameId;
		});

		//add click handlers to this item
		setupClickHandler($(this));

	});
}

export default {
	setupWinnerItems
}



// WEBPACK FOOTER //
// ./mobile-core/src/casino/winners.js